import { httpClient } from "@/httpClient";
import getPharmacyID from "@/utils/pharmacy_code";
import { Supplier } from "./schema";
import { pharmacyClient } from "@/connect";
import { ListSuppliersResponse } from "@/gen/suppliers/list_suppliers_pb";

const API_URL = import.meta.env.VITE_API_URL as string;

export const getSuppliers = async (page: number, pageSize: number, search: string = ''): Promise<ListSuppliersResponse> => {
    return await pharmacyClient.listSuppliers({
        page,
        pageSize,
        searchQuery: search,
    })
};
